import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-ios-development',
  templateUrl: './ios-development.component.html',
  styleUrls: ['./ios-development.component.scss']
})
export class IosDevelopmentComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'iOS Development - Xipe Tech';
  contentDescription = 'XipeTech offers expert iOS development services, creating high-performance, user-friendly mobile apps for iPhone and iPad. We combine innovative design with powerful functionality to deliver exceptional iOS solutions for your business.';
  contentKeywords = 'iOS app development, iPhone app development, iPad app development, custom iOS applications, mobile app development, Swift development, iOS software solutions, iOS app design, iOS developers, Apple app development';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
